import { call, put, takeLatest, all } from "redux-saga/effects"
import {
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_STATUS_WATCHER,
  SAVE_CONFIG_BENCHMARK_WATCHER,
} from "./constants"

import {
  getMeasureColorRangeFailed,
  getMeasureColorRangeSuccess,
  getStatusSuccess,
  getStatusWatcher,
  getStatusFailed,
  saveConfigBenchmarkFailed,
  saveConfigBenchmarkSuccess,
} from "./actions"
import {
  KEY_CHECKBOX_EXCLUDE,
  KEY_ISOLATED_METRICS,
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
  setItem,
} from "../../../utils/storage"
import {
  getDivisionsAvailableApi,
  getMeasureColorRangeApi,
  getMeasureConfigApi,
  getMeasureReportApi,
  getMeasureTotalReportApi,
  putMeasureConfigApi,
} from "../../../utils/routes/routes-report"

export function* getMeasureConfigOptional(params) {
  try {
    return yield call(getMeasureConfigApi, params)
  } catch (e) {
    return {}
  }
}

export function* getStatusSaga(action) {
  try {
    const dataStatus = action.payload

    // Los parámetros de divisions salen todos del pedido (no de info/total), así que se
    // pide en paralelo en vez de esperar a total: una vuelta menos al servidor (VLENG-12055)
    const divisionsParams = {
      excludeParam: dataStatus.isExclude
        ? "&exclude=true"
        : "&exclude=false",
      id_measure: dataStatus.params.id_measure,
      id_division: dataStatus.params.id_divisionParent
        ? dataStatus.params.id_divisionParent
        : dataStatus.params.divisionToUseAmbassador,
      id_segment: dataStatus.params.id_segment,
    }

    const [
      { data: resultMeasure },
      { data: resultTotal, user_type: resultUserType },
      {
        data: resultConfig,
        is_sector_data_available: resultIsSectorDataAvailable,
        company_sectors: resultCompanySectors,
        company_sectors_global: resultCompanySectorsGlobal,
        company_sector: resultCompanySector,
      },
      data,
    ] = yield all([
      call(getMeasureReportApi, dataStatus.params),
      call(getMeasureTotalReportApi, dataStatus.params),
      // La config (benchmark/sectores) es opcional: si falla no debe tumbar todo el reporte
      call(getMeasureConfigOptional, dataStatus.params),
      call(getDivisionsAvailableApi, divisionsParams),
    ])

    if (resultTotal) {
      const divisions = data.data

      if (!resultMeasure.has_isolated_metrics) {
        setItem(KEY_CHECKBOX_EXCLUDE, false)
        setItem(KEY_ISOLATED_METRICS, false)
      }

      yield put(
        getStatusSuccess({
          measureGeneral: resultMeasure,
          measureTotal: resultTotal,
          measureConfig: resultConfig,
          userType: resultUserType,
          isSectorDataAvailable: resultIsSectorDataAvailable,
          divisionsAvailable: divisions,
          companySectors: resultCompanySectors,
          companySectorsGlobal: resultCompanySectorsGlobal,
          companySector: resultCompanySector,
          divisionsData: data,
        })
      )
    } else {
      yield put(getStatusFailed())
    }
  } catch (error) {
    yield put(getStatusFailed())
    if (error.response && error.response.status === 404) {
      action.payload.history.push("/error")
    } else if (error.response && error.response.status === 401) {
      action.payload.history.push("/login")
    }
  }
}

export function* getMeasureColorRangeSaga(action) {
  try {
    const response = yield call(getMeasureColorRangeApi, action.payload)
    yield put(getMeasureColorRangeSuccess(response.data))
  } catch (e) {
    yield put(getMeasureColorRangeFailed())
  }
}

export function* saveConfigBenchmarkSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: result } = yield call(putMeasureConfigApi, dataStatus)
    yield put(saveConfigBenchmarkSuccess(result))
    yield put(
      getStatusWatcher({
        isHome: true,
        id_measure: dataStatus.id_measure,
        history: dataStatus.history,
        isExclude:
          LOCAL_CHECKBOX_EXCLUDE() === "true" &&
          LOCAL_ISOLATED_METRICS() === "true",
        params: {
          id_measure: dataStatus.id_measure,
          id_division: null,
        },
      })
    )
  } catch (e) {
    yield put(saveConfigBenchmarkFailed())
  }
}

export default function* reportAdminSaga() {
  yield takeLatest(GET_STATUS_WATCHER, getStatusSaga)
  yield takeLatest(GET_MEASURE_COLOR_RANGE_WATCHER, getMeasureColorRangeSaga)
  yield takeLatest(SAVE_CONFIG_BENCHMARK_WATCHER, saveConfigBenchmarkSaga)
}
